import { render, staticRenderFns } from "./ExportAdmissionOrLeave.vue?vue&type=template&id=cbf4390e&scoped=true"
import script from "./ExportAdmissionOrLeave.vue?vue&type=script&lang=js"
export * from "./ExportAdmissionOrLeave.vue?vue&type=script&lang=js"
import style0 from "./ExportAdmissionOrLeave.vue?vue&type=style&index=0&id=cbf4390e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf4390e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbf4390e')) {
      api.createRecord('cbf4390e', component.options)
    } else {
      api.reload('cbf4390e', component.options)
    }
    module.hot.accept("./ExportAdmissionOrLeave.vue?vue&type=template&id=cbf4390e&scoped=true", function () {
      api.rerender('cbf4390e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/ExportAdmissionOrLeave.vue"
export default component.exports